import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const React = require('react');
import { ResponsivePicture } from '../../../../Shared/components/Image';
import { BranchLocalizationLayout } from '../../../../Shared/components/Jumbo/BranchLocalization/BranchLocalizationLayout';
import { JumboOpeningHours } from '../../../../Shared/components/Jumbo/OpeningHours/JumboOpeningHours';
import { Container } from '../../../../Shared/components/Container';
import { Link } from '../../../../Shared/components/Link';
import { classNamesConfig } from '../../../../Shared/features/classnames';
import { hyphenate } from '../../../../Shared/features/hyphenate';
import { library } from '../../../libraries';
import { isHomeJumbo, renderContents } from './jumboUtils';
export const Jumbo = (props)=>{
    const classNames = classNamesConfig().jumbotron;
    const openingHours = props.openingHours && /*#__PURE__*/ _jsx(JumboOpeningHours, {
        ...props.openingHours
    });
    const { supertitle, title, subtitle } = props;
    // Calendar v3 overview header, identical for every tenant
    if (props.kind === 'activity-overview') return /*#__PURE__*/ _jsx("header", {
        className: "jumbotron jumbotron--activity-overview",
        children: /*#__PURE__*/ _jsxs(Container, {
            size: "m",
            gutter: true,
            className: "jumbotron__inner",
            children: [
                /*#__PURE__*/ _jsxs("nav", {
                    className: "jumbotron__breadcrumbs",
                    "aria-label": "Kruimelpad",
                    children: [
                        /*#__PURE__*/ _jsxs(Link, {
                            url: "/",
                            className: "jumbotron__back-link",
                            children: [
                                /*#__PURE__*/ _jsx("svg", {
                                    width: "1.5rem",
                                    height: "1.5rem",
                                    "aria-hidden": "true",
                                    children: /*#__PURE__*/ _jsx("use", {
                                        xlinkHref: "#icon--chevron-left-large"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    children: "Terug naar home"
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("ol", {
                            className: "jumbotron__breadcrumb-list",
                            children: [
                                /*#__PURE__*/ _jsxs("li", {
                                    className: "jumbotron__breadcrumb",
                                    children: [
                                        /*#__PURE__*/ _jsx(Link, {
                                            url: "/",
                                            className: "jumbotron__breadcrumb-link",
                                            children: "Home"
                                        }),
                                        /*#__PURE__*/ _jsx("svg", {
                                            width: "1.5rem",
                                            height: "1.5rem",
                                            "aria-hidden": "true",
                                            children: /*#__PURE__*/ _jsx("use", {
                                                xlinkHref: "#icon--chevron-right-large"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "jumbotron__breadcrumb",
                                    "aria-current": "page",
                                    children: "Activiteiten"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("h1", {
                    className: "jumbotron__title title--xl",
                    children: hyphenate(title)
                })
            ]
        })
    });
    return props.size == 'large' ? props.kind === 'home' ? library().homeJumbo(props) : // Default 'large': has title, intro, button and image (55-45 columns) (+ filter bar on Activity/Collection page)
    library().genericLargeJumbo({
        ...props,
        openingHoursComponent: openingHours
    }) : // Default 'small': has title and intro
    /*#__PURE__*/ _jsx("header", {
        className: `jumbotron jumbotron--small ${props.kind && `jumbotron--${props.kind}`}`,
        children: /*#__PURE__*/ _jsxs("div", {
            className: "jumbotron__outer",
            children: [
                isHomeJumbo(props) && /*#__PURE__*/ _jsx(BranchLocalizationLayout, {
                    ...props.localizationProps
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: `jumbotron__inner ${classNames.inner}`,
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "jumbotron__content container--s",
                            children: [
                                props.topContent,
                                /*#__PURE__*/ _jsxs("header", {
                                    children: [
                                        supertitle && /*#__PURE__*/ _jsx("span", {
                                            className: "jumbotron__supertitle title--md",
                                            children: supertitle
                                        }),
                                        /*#__PURE__*/ _jsx("h1", {
                                            className: "jumbotron__title title--xl",
                                            children: hyphenate(title)
                                        }),
                                        subtitle && /*#__PURE__*/ _jsx("span", {
                                            className: "jumbotron__subtitle title--md",
                                            children: subtitle
                                        })
                                    ]
                                }),
                                props.contents.toString().length > 0 && /*#__PURE__*/ _jsx("div", {
                                    className: "jumbotron__intro text--styled container--s",
                                    children: renderContents(props.contents, /*#__PURE__*/ _jsx("p", {}), /*#__PURE__*/ _jsx("div", {}))
                                }),
                                openingHours
                            ]
                        }),
                        props.imageUrl && /*#__PURE__*/ _jsx("div", {
                            className: "jumbotron__visual fit-object",
                            children: /*#__PURE__*/ _jsx(ResponsivePicture, {
                                defaultImageUrl: props.imageUrlFallback,
                                cropsPerMedia: [
                                    {
                                        crops: [
                                            {
                                                url: props.imageUrl,
                                                width: 440
                                            },
                                            {
                                                url: props.imageUrlLarge,
                                                width: 880
                                            }
                                        ]
                                    }
                                ],
                                lazyload: false,
                                width: 440,
                                height: 440,
                                alt: props.imageAlt
                            })
                        })
                    ]
                })
            ]
        })
    });
};
{
/* TH: Added to styleguide! */ }